import { createAction, createReducer } from 'deox';

import { resetApplication } from './resetApplication';
import { pick } from 'ramda';

export interface PrequalOffer {
  // Be sure to update the keys array below when adding new properties.
  // It is used to merge in only keys that are applicable to PrequalOffer
  // I have not found a way to derive the list of keys of an interface as
  // a runtime array, nor did I find a way to enforce that the keys array
  // contains exhaustively all keys in PrequalOffer.
  creditLimit?: number;
  prequalificationId?: string;
}

const prequalOfferKeys: (keyof PrequalOffer)[] = [
  'creditLimit',
  'prequalificationId',
];

export interface PrequalOfferState {
  entity: PrequalOffer;
}

export const defaultState: PrequalOfferState = {
  entity: {},
};

export const mergePrequalOffer = createAction(
  'MERGE_PREQUAL_OFFER',
  resolve => (data: Partial<PrequalOffer>) => resolve(data),
);

export const prequalOfferReducer = createReducer(defaultState, handleAction => [
  handleAction(mergePrequalOffer, (state, { payload: data }) => {
    return {
      ...state,
      entity: {
        ...state.entity,
        ...pick(prequalOfferKeys, data),
      },
    };
  }),

  handleAction(resetApplication, () => defaultState),
]);

export interface MountedState {
  prequalOffer: ReturnType<typeof prequalOfferReducer>;
}

export const selectPrequalOffer = (state: MountedState): PrequalOffer =>
  state.prequalOffer.entity;

export default prequalOfferReducer;
